<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 95vw">
      <div class="modal-header">
        <h5 class="modal-title text-uppercase">Inpatient Turning Sheet</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="patient-profile">
          <div class="profile-header small-header">
            <div>
              <h2 class="text-uppercase">{{ patient.name }}</h2>
              <p>
                Patient ID: {{ patient.hospital_no }} | Ward/Bed:
                {{ patient.ward + "/ " + patient.bed }}
              </p>
            </div>
          </div>
          <div class="profile-details">
            <div class="detail">
              <label>Turning Schedule:</label>
              <span class="schedule-info">Q2H (Every 2 Hours)</span>
            </div>
            <!-- <div class="detail full-width">
              <label>Skin Assessment Notes:</label>
              <span class="medical-notes"
                >Sacrum Grade 1 Redness. Use pressure relief cushions.</span
              >
            </div> -->
          </div>
        </div>

        <hr class="section-divider" />

        <div class="turning-entry-section">
          <h3>Record New Turn</h3>
          <div class="new-entry-form">
            <div style="width: 25%;" class="form-group">
              <label for="turnTime">Time of Turn</label>
              <input
                type="datetime-local"
                id="turnTime"
                v-model="newTurn.time"
                class="input-field"
              />
            </div>

            <div  style="width: 25%;"  class="form-group">
              <label for="turnPosition">Position</label>
              <select
                id="turnPosition"
                v-model="newTurn.position"
                class="input-field"
              >
                <option value="" disabled>Select Position</option>
                <option value="Left">Left Side</option>
                <option value="Right">Right Side</option>
                <option value="Back">Supine (Back)</option>
                <option value="Prone">Prone (Tummy)</option>
                <option value="Sitting">Sitting Up</option>
              </select>
            </div>

            <div style="width: 25%;" class="form-group">
              <label for="notes">Note</label>
              <input
                type="text"
                id="notes"
                v-model="newTurn.notes"
                placeholder="Notes"
                class="input-field"
              />
            </div>

            <div style="width: 20%;" class="form-group">
              <label for="turnSignature">Staff Signature</label>
              <input
                type="text"
                id="turnSignature"
                v-model="newTurn.signature"
                placeholder="Your Name/ID"
                class="input-field"
              />
            </div>

            <button
              type="button"
              class="btn btn-add-log"
              @click="addTurnEntry"
              :disabled="!isNewTurnValid"
            >
              Log Turn
            </button>
          </div>
        </div>

        <hr class="section-divider" />

        <div class="turning-history-section">
          <h3>Recent Turning History (Recent)</h3>

          <table class="history-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Position</th>
                <th>Staff</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(entry, index) in turnHistory" :key="index">
                <td>{{ entry.time }}</td>
                <td
                  :class="{ 'highlight-position': entry.position === 'Prone' }"
                >
                  {{ entry.position }}
                </td>
                <td>{{ entry.signature }}</td>
                <td>{{ entry.notes || "N/A" }}</td>
              </tr>
              <tr v-if="turnHistory.length === 0">
                <td colspan="4" class="empty-message">
                  No turns logged in the last 24 hours.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import showNotification from "../../notification/notify";
export default {
  name: "InpatientTurningSheetModal",
  props: {
    patient: { type: Object, required: true },
    staffSignature: { type: String, default: "Staff User" },
    visit_id: { type: [String, Number], required: true },
  },
  data() {
    return {
      newTurn: {
        time: this.getCurrentTime(),
        position: "",
        signature: this.staffSignature,
        notes: "",
        visit_id: this.visit_id,
      },
      // Mock History Data (replace with actual API data)
      turnHistory: [],
    };
  },
  computed: {
    isNewTurnValid() {
      return (
        this.newTurn.time &&
        this.newTurn.position &&
        this.newTurn.signature.trim() !== ""
      );
    },
  },
  methods: {
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    async addTurnEntry() {
      if (!this.isNewTurnValid) return;

      const response = await generalApiRequest(
        "turning-sheets/",
        "POST",
        this.newTurn,
        1
      );

      if (response.data) {
        this.newTurn.time = this.getCurrentTime();
        this.newTurn.position = "";
        this.newTurn.notes = "";
        this.newTurn.signature = this.staffSignature;
        showNotification("Turn Record Created Successfully");
        this.loadData();
      }
    },
    closeModal() {
      this.$emit("close-turning-modal");
    },
    // Mock method to load data based on props
    async loadData() {
      const response = await generalApiRequest(
        "turning-sheets/" + this.visit_id,
        "GET",
        {},
        1
      );
      this.turnHistory = response;
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
/* --- Base Modal Styles --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  color: #343a40;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}

.close:hover {
  color: #dc3545;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* --- Patient Profile Styles --- */
.patient-profile {
  margin-bottom: 1rem;
}

.profile-header.small-header {
  padding-bottom: 5px;
  border-bottom: 1px dashed #ced4da;
  margin-bottom: 10px;
}

.profile-header h2 {
  margin: 0;
  font-size: 1.4rem;
  color: #343a40;
}

.profile-header p {
  margin: 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.profile-details {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  font-size: 0.95rem;
}

.detail {
  display: flex;
  flex-direction: column;
}

.detail label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 2px;
  font-size: 0.85rem;
}

.schedule-info {
  color: #007bff;
  font-weight: 500;
}

.full-width {
  grid-column: 1 / -1;
}

.medical-notes {
  color: #dc3545;
  font-weight: 500;
}

.section-divider {
  border: 0;
  border-top: 1px solid #e9ecef;
  margin: 1.5rem 0;
}

/* --- Turning Entry Section --- */
.turning-entry-section h3 {
  margin-top: 0;
  color: #28a745;
  font-size: 1.2rem;
  margin-bottom: 15px;
}

.new-entry-form {
  display: flex;
  grid-template-columns: 1fr 1fr 1.5fr 150px; /* Time | Position | Signature | Button */
  gap: 15px;
  align-items: flex-end;
  padding: 15px;
  border: 1px solid #28a745;
  border-radius: 6px;
  background-color: #f1fcf5;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 5px;
}

.input-field {
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.95rem;
}

.input-field:focus {
  border-color: #28a745;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.btn-add-log {
  background-color: #28a745;
  color: white;
  border: 1px solid #28a745;
  padding: 10px 15px;
  font-weight: 600;
  height: 40px;
  margin-left: auto; /* 👈 works inside display:flex parent */
}

.btn-add-log:hover:not(:disabled) {
  background-color: #1e7e34;
  border-color: #1c7430;
}

.btn-add-log:disabled {
  background-color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  opacity: 0.65;
}

/* --- History Section --- */
.turning-history-section h3 {
  margin-top: 0;
  color: #343a40;
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.history-table th,
.history-table td {
  border: 1px solid #dee2e6;
  padding: 10px 12px;
  text-align: left;
  font-size: 0.9rem;
}

.history-table th {
  background-color: #f8f9fa;
  font-weight: 700;
  color: #495057;
}

.history-table tr:nth-child(even) {
  background-color: #f1f3f5;
}

.history-table td.highlight-position {
  background-color: #fff3cd; /* Light yellow background for prone, indicating high risk/focus */
  font-weight: 600;
}

.empty-message {
  text-align: center;
  font-style: italic;
  color: #6c757d;
  padding: 20px;
}

/* --- Utility Button Styles --- */
.btn {
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s, border-color 0.2s;
  border: 1px solid transparent;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style>
